module.exports = __webpack_public_path__ + "img/bg2.de5b2ee0.png";